var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import React, { useEffect, useRef, useState } from 'react';
var TransitionState;
(function (TransitionState) {
    TransitionState[TransitionState["Ready"] = 0] = "Ready";
    TransitionState[TransitionState["Hiding"] = 1] = "Hiding";
    TransitionState[TransitionState["Showing"] = 2] = "Showing";
})(TransitionState || (TransitionState = {}));
var TRANSITION_STATE_OPACITIES = (_a = {},
    _a[TransitionState.Ready] = undefined,
    _a[TransitionState.Hiding] = 0,
    _a[TransitionState.Showing] = 1,
    _a);
var DEFAULT_CONTAINER = function (props) {
    return React.createElement("div", __assign({}, props));
};
/**
 * Component that can cross-fade between states.
 *
 * When the state changes, the currently rendered component first fades out, and then the new component fades in.
 */
export var AnimatedCrossFade = function (_a) {
    var state = _a.state, container = _a.container, children = _a.children;
    container !== null && container !== void 0 ? container : (container = DEFAULT_CONTAINER);
    var _b = useState(state), currentState = _b[0], setCurrentState = _b[1];
    var ref = useRef(null);
    var _c = useState(TransitionState.Ready), transitionState = _c[0], setTransitionState = _c[1];
    var opacity = TRANSITION_STATE_OPACITIES[transitionState];
    useEffect(function () {
        if (state !== currentState) {
            setTransitionState(TransitionState.Hiding);
        }
    }, [state]);
    return container({
        ref: ref,
        style: {
            transition: 'opacity 0.1s',
            opacity: opacity,
        },
        onTransitionEnd: function (event) {
            if (event.target === ref.current) {
                setCurrentState(state);
                switch (transitionState) {
                    case TransitionState.Hiding:
                        setTransitionState(TransitionState.Showing);
                        break;
                    case TransitionState.Showing:
                        setTransitionState(TransitionState.Ready);
                        break;
                }
            }
        },
        children: children(currentState),
    });
};
